import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { FuseNavigationItem } from '@fuse/components/navigation';
import {cloneDeep} from 'lodash-es';
import nav from '../../../../navigation.json';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { ModuleService } from 'app/services/module.service';
import { Module } from 'app/models/module.model';

@Component({
    selector     : 'classic-layout',
    templateUrl  : './classic.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ClassicLayoutComponent implements OnInit, OnDestroy
{
    user: User;
    modules: Module[];
    isScreenSmall: boolean;
    navigation: Navigation;
    // @ts-ignore
    defaultNavigation: FuseNavigationItem[] = nav;
    private readonly _defaultNavigation: FuseNavigationItem[] = this.defaultNavigation;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _userService: UserService,
        private _moduleService: ModuleService,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.navigation = {
            default   : cloneDeep(this._defaultNavigation)
        };

        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {
                this.isScreenSmall = !matchingAliases.includes('md');
            });

        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
            });



        this.navigationFilter();
    }

    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    navigationFilter() {
        this.navigation.default = [];

        this._moduleService.getModulesForUser(this.user.id).subscribe((_modules) => {
            this.modules = _modules;

            const modules = [];
            this.modules.forEach((module) => {
                if(!modules.includes(module.nom)){
                    modules.push(module.nom);
                }
            });

            this.defaultNavigation[0].children = this.defaultNavigation[0].children.filter(x =>(modules.includes(x.title)));
            this.navigation.default = this.defaultNavigation;
        });
    }
}
